import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../i18n/LanguageContext";
import QuickActions from "./QuickActions";
import { trackPhoneClick, trackEmailClick, trackWhatsAppClick } from "../lib/tracking";
import {
  TEL_HREF,
  MAIL_HREF,
  MAIL_PRO_HREF,
  WA_HREF,
  PHONE_DISPLAY,
  EMAIL,
  EMAIL_PRO,
} from "./QuickActions";

export default function Footer() {
  const { t } = useLang();
  const year = new Date().getFullYear();

  return (
    <footer data-testid="site-footer" className="bg-[#0A0A0A] text-[#F7F7F9]">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 py-20 md:py-24">
        <div className="grid grid-cols-12 gap-10 md:gap-16">
          <div className="col-span-12 md:col-span-6">
            <div className="flex items-baseline gap-3 mb-6">
              <span className="font-display text-5xl md:text-6xl tracking-tighter">
                LA<span className="text-[#DC2626]">K</span>A
              </span>
              <span className="font-mono text-[10px] tracking-[0.22em] uppercase text-[#F7F7F9]/60">
                Est. 2010
              </span>
            </div>
            <p className="text-base md:text-lg font-light max-w-md text-[#F7F7F9]/80">
              <span className="text-[#DC2626]">L</span>oge d'Architecture KERKOUB Abdelkrim. {t.footer.tagline}
            </p>
            <div className="mt-8">
              <QuickActions variant="footer" source="footer" />
            </div>
          </div>

          <div className="col-span-6 md:col-span-3">
            <div className="font-mono text-[10px] tracking-[0.25em] uppercase text-[#F7F7F9]/60 mb-5">
              {t.footer.links}
            </div>
            <ul className="space-y-3 text-sm">
              <li><a href="/#about" className="hover:text-[#D35400] transition-colors">{t.nav.studio}</a></li>
              <li><a href="/#expertise" className="hover:text-[#D35400] transition-colors">{t.nav.expertise}</a></li>
              <li><a href="/#projects" className="hover:text-[#D35400] transition-colors">{t.nav.projects}</a></li>
              <li><a href="/#process" className="hover:text-[#D35400] transition-colors">{t.nav.process}</a></li>
              <li><Link to="/contact" className="hover:text-[#D35400] transition-colors">{t.nav.contact}</Link></li>
            </ul>
          </div>

          <div className="col-span-6 md:col-span-3">
            <div className="font-mono text-[10px] tracking-[0.25em] uppercase text-[#F7F7F9]/60 mb-5">
              {t.footer.social}
            </div>
            <ul className="space-y-3 text-sm">
              <li>
                <a
                  href="https://www.linkedin.com/in/karim-kerkoub-56221361/"
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-[#D35400] transition-colors"
                >
                  LinkedIn · Karim Kerkoub
                </a>
              </li>
              <li>
                <a
                  href={TEL_HREF}
                  onClick={() => trackPhoneClick("footer-list")}
                  className="hover:text-[#D35400] transition-colors"
                >
                  {PHONE_DISPLAY}
                </a>
              </li>
              <li>
                <a
                  href={MAIL_HREF}
                  onClick={() => trackEmailClick("footer-list")}
                  className="hover:text-[#D35400] transition-colors"
                >
                  {EMAIL}
                </a>
              </li>
              <li>
                <a
                  href={MAIL_PRO_HREF}
                  onClick={() => trackEmailClick("footer-pro")}
                  className="hover:text-[#D35400] transition-colors break-all"
                >
                  {EMAIL_PRO}
                </a>
              </li>
              <li>
                <a
                  href={WA_HREF}
                  target="_blank"
                  rel="noreferrer"
                  onClick={() => trackWhatsAppClick("footer-list")}
                  className="hover:text-[#D35400] transition-colors"
                >
                  WhatsApp
                </a>
              </li>
              <li className="text-[#F7F7F9]/60">Strasbourg — Luxembourg</li>
            </ul>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-[#F7F7F9]/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="font-mono text-[10px] tracking-[0.22em] uppercase text-[#F7F7F9]/50">
            © {year} LAKA — {t.footer.rights}
          </div>
          <div className="font-mono text-[10px] tracking-[0.22em] uppercase text-[#F7F7F9]/50">
            48°34'N · 7°45'E
          </div>
        </div>
      </div>
    </footer>
  );
}
